import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import SIPCalculator from "../components/SIPCalculator";

function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-6xl px-4 ${className}`}>{children}</div>;
}

export default function SIPs() {
  return (
    <div className="min-h-screen bg-white">
      <Container className="py-10">
        <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-950">
          <Sparkles className="h-4 w-4" />
          SIPs
        </div>

        <h1 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl text-slate-900">
          Build wealth using disciplined SIPs
        </h1>
        <p className="mt-2 max-w-2xl text-slate-600">
          Try the SIP calculator below. Next we can add a SIP Builder (goal → SIP recommendation).
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <SIPCalculator />

          <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm">
            <div className="text-base font-semibold text-slate-900">Premium SIP features to add next</div>
            <div className="mt-4 space-y-3">
              {[
                "Goal → monthly SIP recommendation",
                "Step-up SIP (increase SIP each year)",
                "Timeline + progress bar",
                "Risk profile based baskets",
                "Monthly PDF report + reminders",
              ].map((t) => (
                <div key={t} className="flex items-center gap-2 text-sm text-slate-700">
                  <span className="h-2 w-2 rounded-full bg-emerald-950" />
                  {t}
                </div>
              ))}
            </div>

            <a
              href="/mutual-funds"
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-emerald-950 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-900"
            >
              Explore Mutual Funds <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
}
